module.exports = __webpack_public_path__ + "img/bar-chart-fill.3f7508ef.svg";